import { usePatents } from "src/patents/PatentsProvider";
import { IpRightsContext } from "../interfaces/IpRights";
import { toIpRight, useIpContext, useIpRights } from "./patent_renewals";
import _ from "lodash";

export function PRIpRightsProvider({ children }) {
  const {ownerByCostCenterId} = useIpContext();
  const {ipRights: prIpRights} = useIpRights();
  const { memberByReference } = usePatents();

  const ipRights = (prIpRights ?? []).map(ipRight => toIpRight(ipRight, ownerByCostCenterId))
  const ipRightById = _.keyBy(ipRights, ipRight => ipRight.id);

  const ipRightByFamilyMemberId = _(ipRights)
    .map(ipRight => [memberByReference[ipRight.clientReference]?.familyMemberId, ipRight])
    .filter(([familyMemberId, _]) => familyMemberId !== undefined)
    .fromPairs()
    .value() // as Record<number, IpRight>

  const value = {
    ipRights,
    ipRightById,
    ipRightByFamilyMemberId,
    stopIpRight: (ipRight) => Promise.resolve(), // TODO
  };

  return (
    <IpRightsContext.Provider {...{value}}>
      {children}
    </IpRightsContext.Provider>
  )
}